// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = () => ({
  map: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    top: 0,
    bottom: 0,
    width: '100%',
    flex: 1,
  },
  mapContainer: {
    position: 'relative',
    flex: 1,
    minHeight: 0,
  },
  sideBarIcon: {
    width: 24,
    height: 24,
    color: 'rgba(2, 30, 64, 1)',
    transform: 'rotate(180deg)',
  },
  sideBarIconContainer: {
    position: 'absolute',
    top: 100,
    left: 20,
    width: 45,
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: '12px',
    cursor: 'pointer',
    boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.1)',
    zIndex: 3,
  },
});

export default styles;
